import { useCallback, useEffect, useState } from 'react';

const DEFAULT_DEBOUNCE_MS = 300;

export const useDebouncedSearchInput = (debounceMs: number = DEFAULT_DEBOUNCE_MS) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, debounceMs);

    return () => clearTimeout(timer);
  }, [searchQuery, debounceMs]);

  const handleQueryChange = useCallback((query: string) => {
    setSearchQuery(query);
    setIsOpen(query.length > 0);
  }, []);

  const clearSearch = useCallback(() => {
    setSearchQuery('');
    setDebouncedSearchQuery('');
    setIsOpen(false);
  }, []);

  const isDebouncing = searchQuery.length > 0 && searchQuery !== debouncedSearchQuery;

  return {
    searchQuery,
    setSearchQuery,
    debouncedSearchQuery,
    isOpen,
    setIsOpen,
    handleQueryChange,
    clearSearch,
    isDebouncing,
  };
};
